import React from 'react'
import TranspondLogo from './transpond.svg'

export const MAILCHIMP_LOGO = 'https://cdn1.ourmailserv.com/siteContent/appLogos/10/mailchimp.png'

export default function Mailchimp2Icons({ size = 'lg', animateConnector = false }) {
    const markClass = size === 'sm' ? 'mailchimp2-icons__mark mailchimp2-icons__mark--sm' : 'mailchimp2-icons__mark'
    const rootClass = animateConnector ? 'mailchimp2-icons mailchimp2-icons--active' : 'mailchimp2-icons'
    const connectorClass = animateConnector
        ? 'mailchimp2-icons__connector mailchimp2-icons__connector--active'
        : 'mailchimp2-icons__connector'
    return (
        <div className={rootClass}>
            <img src={MAILCHIMP_LOGO} alt='Mailchimp' className={markClass} />
            <div className={connectorClass} aria-hidden='true' />
            <span className={`${markClass} mailchimp2-icons__mark--transpond`}>
                <img src={TranspondLogo} alt='Transpond' />
            </span>
        </div>
    )
}

export function Mailchimp2MapCells({ from, fromSub, to }) {
    const markClass = 'mailchimp2-icons__mark mailchimp2-icons__mark--sm'
    return (
        <>
            <div className='mailchimp2-map-table__cell mailchimp2-map-table__from'>
                <div className='mailchimp2-icons__side'>
                    <img src={MAILCHIMP_LOGO} alt='' className={markClass} />
                    <div className='mailchimp2-icons__copy'>
                        <div className='mailchimp2-icons__label'>{from}</div>
                        {fromSub && <div className='mailchimp2-icons__sub'>{fromSub}</div>}
                    </div>
                </div>
            </div>
            <div className='mailchimp2-map-table__cell mailchimp2-map-table__arrow'>
                <div className='mailchimp2-icons__connector' aria-hidden='true' />
            </div>
            <div className='mailchimp2-map-table__cell mailchimp2-map-table__to'>
                <div className='mailchimp2-icons__side'>
                    <span className={`${markClass} mailchimp2-icons__mark--transpond`}>
                        <img src={TranspondLogo} alt='' />
                    </span>
                    <div className='mailchimp2-icons__copy'>
                        <div className='mailchimp2-icons__label'>{to}</div>
                    </div>
                </div>
            </div>
        </>
    )
}
